import { cn } from '@/lib/utils';
import { CheckIcon, CircleIcon, LoaderIcon } from 'lucide-react';

const STAGES = [
	{ id: 'workspace', label: 'Подготовка' },
	{ id: 'icon', label: 'Иконка' },
	{ id: 'config', label: 'Конфиг' },
	{ id: 'gradle', label: 'Сборка APK' },
	{ id: 'encrypt', label: 'Шифрование' },
] as const;

interface BuildStageStepperProps {
	currentStage?: string | null;
	className?: string;
}

function getStageIndex(stage: string | null | undefined): number {
	if (!stage || stage === 'queued') return -1;
	return STAGES.findIndex(item => item.id === stage);
}

export default function BuildStageStepper({ currentStage, className }: BuildStageStepperProps) {
	const currentIndex = getStageIndex(currentStage);

	return (
		<div className={cn('flex flex-wrap gap-2', className)}>
			{STAGES.map((stage, index) => {
				const isDone = currentIndex > index;
				const isCurrent = currentIndex === index;
				const isPending = currentIndex < index;

				return (
					<div
						key={stage.id}
						className={cn(
							'flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs',
							isDone && 'border-chart-2/40 bg-chart-2/10 text-chart-2',
							isCurrent && 'border-chart-5/40 bg-chart-5/10 text-chart-5',
							isPending && 'border-border bg-muted/40 text-muted-foreground',
						)}
					>
						{isDone ? (
							<CheckIcon className='size-3.5 shrink-0' />
						) : isCurrent ? (
							<LoaderIcon className='size-3.5 shrink-0 animate-spin' />
						) : (
							<CircleIcon className='size-3.5 shrink-0 opacity-50' />
						)}
						<span>{stage.label}</span>
					</div>
				);
			})}
		</div>
	);
}
